import { api } from '../../api/client';
import { API_BASE_URL } from '../../config/api';
import { getFirstValue } from '../Account/profileFormUtils';

/**
 * @param {unknown} raw
 */
function normalizeAddressId(raw) {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function normalizeUserAddress(raw) {
  const safe = raw && typeof raw === 'object' ? raw : {};
  return {
    id: normalizeAddressId(safe.id ?? safe.userAddressId ?? safe.addressId),
    name: String(safe.name || ''),
    address: String(safe.address || ''),
    city: String(safe.city || ''),
    state: String(safe.state || ''),
    country: String(safe.country || ''),
    postalCode: String(getFirstValue(safe, ['postalCode', 'postal_code']) || ''),
    latitude: Number.isFinite(Number(safe.latitude)) ? Number(safe.latitude) : null,
    longitude: Number.isFinite(Number(safe.longitude)) ? Number(safe.longitude) : null,
    isPrimary: Boolean(safe.isPrimary ?? safe.is_primary),
    type: Number.isFinite(Number(safe.type)) ? Number(safe.type) : 3,
  };
}

/**
 * @param {string} token
 */
export async function fetchUserAddresses(token) {
  const { data } = await api.get(`${API_BASE_URL}/auth/getUserAddress`, {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    timeoutMs: 20000,
  });
  const list = Array.isArray(data?.data) ? data.data : [];
  return list.map(normalizeUserAddress).filter((a) => a.id != null);
}

/** Re-export for cart + account (single storage key). */
export {
  getStoredSelectedAddressId,
  storeSelectedAddressId,
  clearSelectedAddressId,
} from './cartDistanceUtils';
